import FormAudit from '../sub-pages/form-audit';
import { Loading } from 'element-ui';

export default[
    {
        show(row,extra){
            return true
        },
        tag:'my-btn',
        type:'detail',
        text:'详情',
        click(row,extra){
            this.goto({
                path: '/bidding/projectflow/dingbiao/zbhxrgs/detail',
                query: {
                    id: row.gscode,
                    type:'1'
                }
            });
        }
    },{
        show(row,extra){
            return row.shbj==='1'
        },
        tag:'el-button',
        type:'text',
        icon: 'el-icon-finished',
        text: '审核',
        click(row,extra){
            this.dialogOpen(FormAudit,'审核')
        }
    },{
        show(row,extra){
            return row.shbj==='6'
        },
        tag:'el-button',
        type:'text',
        icon: 'el-icon-refresh-right',
        text: '查看同步状态',
        click(row,extra){
            // 加载
            var loadingInstance = Loading.service({
                body : true,
                text : '加载中'
            });
            this.$ajax({
                url:`${this.getGetters('mngUrl')}/manage/business/auditzbhxrgs/gettbzt.json`,
                data:{
                    ggcode:row.gscode
                },
                callback:(data, res)=>{
                    ShowMsgBox(res.msg,'info')
                },
                complete:()=>{
                    loadingInstance.close();
                }
            })
        }
    },
]